// 应用全局配置
module.exports = {
  baseUrl: 'https://conghuibao.com.cn/prod-api',
  pageUrl: 'https://conghuibao.com.cn',
  appid: 'wx883a35920f0e9d0f',//聪惠保
  indexPage: 'https://conghuibao.com.cn/',

  // baseUrl: 'http://localhost:9090/dev-api',//本地
  // pageUrl: 'http://localhost:9091',
  // appid: 'wx999c849f3540dc6f',//测试
  // indexPage: 'http://localhost:9091/',
  appInfo: {
    // 应用名称
    name: '聪惠保', version: '202604281650' // 应用版本
  }
};
